"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Flex = exports.Box = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledSystem = require("styled-system");
var _css = _interopRequireDefault(require("@styled-system/css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var sx = function sx(props) {
  return (0, _css["default"])(props.sx)(props.theme);
};
var base = function base(props) {
  return (0, _css["default"])(props.__css)(props.theme);
};
var theme = function theme(_ref) {
  var _ref$tx = _ref.tx,
    tx = _ref$tx === void 0 ? 'variants' : _ref$tx;
  return (0, _styledSystem.variant)({
    scale: tx
  });
};
var Box = exports.Box = _styledComponents["default"].div.withConfig({
  componentId: "sc-1e38spu-0"
})({
  boxSizing: 'border-box',
  margin: 0,
  minWidth: 0
}, base, theme, sx, _styledSystem.space, _styledSystem.color, _styledSystem.layout, _styledSystem.flexbox, _styledSystem.typography, _styledSystem.border, _styledSystem.position);
var Flex = exports.Flex = (0, _styledComponents["default"])(Box).withConfig({
  componentId: "sc-1e38spu-1"
})({
  display: 'flex'
});